<template>
  <div class="companies">
    <section class="section-header">
      <h1>
        <Link to="/admin/users">Admin</Link>
        <Link to="/admin/users">{{ $t('meta.users') }}</Link>
        <Link :to="`/admin/users/${this.$route.params.uuid}`">{{ user.first_name }} {{ user.last_name }}</Link>
        {{ $t('companies.addCompany') }}
      </h1>
      <div class="meta"></div>
    </section>

    <div class="body-content cf">
      <div class="entries-wrap">
        <admin-nav></admin-nav>
        <div class="body">
          <CompanyUser
            :formTitle="
              $t('admin.user.addUserCompany', {
                firstname: user.first_name,
                lastName: user.last_name,
              })
            "
            :user="user"
            @submit="addCompanyUser"
            :templateMode="'add'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyUser from '@/views/admin/users/companies/CompanyUser.vue'

import AdminNav from '@/components/admin_nav'

import adminsApi from '@/api/admin'
import companyUsersApi from '@/api/companyUsers'

export default {
  name: 'admin_user',
  components: {
    AdminNav,
    CompanyUser,
  },
  data() {
    return {
      user: {},
    }
  },
  methods: {
    async addCompanyUser(formData) {
      const createSuccessful = await companyUsersApi.create({
        company_uuid: formData.companyUuid,
        roles: formData.roles,
        user: this.user,
      })

      if (createSuccessful) {
        await this.$router.push(`/admin/users/${this.$route.params.uuid}`)
      }
    },
  },
  async mounted() {
    this.user = await adminsApi.getUser(this.$route.params.uuid)
  },
}
</script>
